import { StyleSheet } from 'react-native';
import {
  fontSizeMedium,
  errorRed,
  lightGrey,
  fontFamilyBold,
} from '../../constants/palette';

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    // marginVertical: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkEmailText: {
    fontSize: fontSizeMedium,
  },
  emailContainer: {
    paddingBottom: 20,
    width: 250, // FIXME: HACK
  },
  emailText: {
    fontSize: fontSizeMedium,
    fontFamily: fontFamilyBold,
  },
  logo: { marginBottom: 40 },
  signUpErrorText: {
    marginTop: -20,
  },
  subHeader: {
    marginBottom: 20,
    width: 250,
    textAlign: 'center',
  },
});

export default styles;
